module.exports = __webpack_public_path__ + "img/Google_Authenticator_April_2023.ad0f1a47.svg";